import { createActionTypes } from '../../../../util/createActionsHelpers';

export const GET_TOP_READING_ARTICLES = createActionTypes(
  'GET_TOP_READING_ARTICLES'
);
